import React, { useState, useEffect } from 'react';
import Header from './Header.js';

import configData from './Config';
import { Helmet } from 'react-helmet';

import homepage_section1 from './Assets/homepage_section1.jpg';
import homepage_section2 from './Assets/homepage_section2.jpg';
import homepage_section3 from './Assets/homepage_section3.jpg';
import homepage_facebookicon from './Assets/homepage_facebookicon.png';
import homepage_linkedinicon from './Assets/homepage_linkedinicon.png';
import homepage_instagramicon from './Assets/homepage_instagramicon.png';

import './HomePage.css';

function Homepage({ state, setState }) {
    const [subscriptioncode, setSubscriptioncode] = useState('');
    const [planoption, setPlanoption] = useState(1);
    const [paymentoption, setPaymentoption] = useState(1);

    const handleClose = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const handlePlan = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Plan state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Plan' }))
    }

    const handleDemo = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Demo state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Demo' }))
    }

    const handleApple = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AppStore state={state} setState={setState} />, modaltype: 'small', modaltitle: 'App Store' }))
    }

    useEffect(() => {
        let code = '';

        if (planoption === '1' && paymentoption === '1') {
            code = 'SUBBASICMONTHLY';
        } else if (planoption === '1' && paymentoption === '12') {
            code = 'SUBBASICYEARLY';
        } else if (planoption === '2' && paymentoption === '1') {
            code = 'SUBPROMONTHLY';
        } else if (planoption === '2' && paymentoption === '12') {
            code = 'SUBPROYEARLY';
        }

        setSubscriptioncode(code);
    }, [planoption, paymentoption]);

    function Plan() {
        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            You’ve selected the <strong>{subscriptioncode}</strong>, and your subscription will be activated once payment is received. Please note that we are currently only accepting <strong>cash payments</strong>.
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={handleClose}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function Demo() {
        const startDemo = () => {
            setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
            setState(state => ({
                ...state,
                user: {
                    userid: '669b5d6facee2',
                    usertoken: '1fdd91bb65550a8b03306c8f1e43b59e',
                    useremail: 'demouser@demo.com',
                    username: 'demo_user',
                    usertype: '0',
                }
            }))
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>Building XYZ 1344 Demo. Press Start Demo to start.</div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={startDemo}>Start Demo</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function AppStore() {
        const handleCloseAppStore = () => {
            setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>IOS App is still under development.</div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={handleCloseAppStore}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='homepage'>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="description" content="Industrial Dynamics - Industrial Process Automation Software for Machines, Sensors, and AI Systems" />
                <meta name="keywords" content="industrial automation, process automation, PLC systems, IoT sensors, AI automation, smart factory, machine control software" />
                <meta name="author" content="Industrial Dynamics" />
                <meta property="og:title" content="Industrial Dynamics - Industrial Process Automation Software" />
                <meta property="og:description" content="Automate machines, monitor sensors, and optimize industrial processes using AI-driven automation." />
                <meta property="og:image" content={homepage_section1} />
                <meta property="og:url" content={window.location.href} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Industrial Dynamics - Industrial Automation Platform" />
                <meta name="twitter:description" content="Control machines, manage I/O systems, and leverage AI for smarter industrial operations." />
                <meta name="twitter:image" content={homepage_section1} />
                <title>Industrial Dynamics - Process Automation Software</title>
            </Helmet>

            <Header state={state} setState={setState} />

            <div className='homepage_section'>
                <div className='homepage_sectionleft'>
                    <h1 className='homepage_title'>Industrial Dynamics - Process Automation Software</h1>
                    <p className='homepage_description'>
                        Industrial Dynamics is a powerful industrial automation platform designed to control machines,
                        manage input/output systems, and monitor sensors in real time.
                        Our cloud-enabled system integrates PLCs, smart devices, and AI models
                        to optimize production efficiency, reduce downtime, and enhance operational control.
                    </p>
                </div>
                <div className='homepage_sectionright'>
                    <div className='homepage_paymentplans'>
                        <div className="homepage_paymentplan">
                            <h3>Plan</h3>
                            <select className='homepage_paymentplanselect' value={planoption} onChange={(e) => setPlanoption(e.target.value)}>
                                <option value={1}>Smarter Automation</option>
                                <option value={2}>Enterprise Automation</option>
                            </select>
                            <h3>Option</h3>
                            <select className='homepage_paymentplanselect' value={paymentoption} onChange={(e) => setPaymentoption(e.target.value)}>
                                <option value={1}>Monthly</option>
                                <option value={12}>Yearly</option>
                            </select>
                            {planoption == 1 && paymentoption == 1 && <p className="homepage_paymentplanprice">$4/Month</p>}
                            {planoption == 1 && paymentoption == 12 && <p className="homepage_paymentplanprice">$50/Year</p>}
                            {planoption == 2 && paymentoption == 1 && <p className="homepage_paymentplanprice">$10/Month</p>}
                            {planoption == 2 && paymentoption == 12 && <p className="homepage_paymentplanprice">$110/Year</p>}
                            {planoption == 1 &&
                                <ul className='homepage_paymentplanfeatures'>
                                    <li>Limited to 1 Project</li>
                                    <li>One-user Access</li>
                                    <li>Property Management</li>
                                    <li>Facilities Management CAFM</li>
                                </ul>
                            }
                            {planoption == 2 &&
                                <ul className='homepage_paymentplanfeatures'>
                                    <li>Multiple Projects</li>
                                    <li>Multi-user Access</li>
                                    <li>User Permissions</li>
                                    <li>Property Management Accounting</li>
                                    <li>Facilities Management CAFM</li>
                                    <li>Mobile App Access</li>
                                </ul>
                            }
                            <button className='homepage_planbutton' onClick={handlePlan}>Start Plan</button>
                            <button className='homepage_demobutton' onClick={handleDemo}>Demo Building XYZ</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='homepage_section'>
                <div className='homepage_sectionleft'>
                    <h1 className='homepage_title'>Smart Industrial Automation</h1>
                    <p className='homepage_description'>
                        Transform traditional factories into intelligent production environments.
                        Industrial Dynamics connects machines, PLC controllers, actuators, and sensors
                        into a unified automation platform.
                        Monitor real-time machine inputs and outputs, automate workflows,
                        and gain complete visibility over your production lines.
                        Reduce human error, improve safety, and maximize operational efficiency
                        through centralized industrial control.
                    </p>
                    <h1 className='homepage_title'>AI & IoT Integration</h1>
                    <p className='homepage_description'>
                        Deploy industrial IoT sensors across your machines to capture temperature,
                        vibration, pressure, energy consumption, and performance metrics.
                        Leverage AI-powered analytics to detect anomalies,
                        predict equipment failures, and optimize production cycles.
                        Industrial Dynamics enables predictive maintenance,
                        smart alerts, and automated decision-making,
                        ensuring continuous production with minimal downtime.
                    </p>
                </div>
                <div className='homepage_sectionright'>
                    <img className='homepage_image' src={homepage_section1} alt="IOT" />
                </div>
            </div>

            <div className='homepage_section'>
                <div className='homepage_sectionleft'>
                    <img className='homepage_image' src={homepage_section2} alt="Building Automation" />
                </div>
                <div className='homepage_sectionright'>
                    <h1 className='homepage_title'>Machine & Process Control</h1>
                    <p className='homepage_description'>
                        Gain full control over your industrial equipment with real-time I/O monitoring.
                        Track digital and analog inputs and outputs,
                        automate motor controls, valves, conveyors, robotic arms,
                        and other production systems from a single dashboard.
                        Configure logic rules, triggers, and automation sequences
                        to streamline complex manufacturing processes.
                    </p>
                    <h1 className='homepage_title'>Production Monitoring & Analytics</h1>
                    <p className='homepage_description'>
                        Monitor production output, downtime, cycle times,
                        and operational KPIs across multiple production lines.
                        Generate real-time dashboards and performance reports
                        to make data-driven decisions.
                        Industrial Dynamics provides deep analytics tools
                        to improve efficiency and reduce operational waste.
                    </p>
                    <h1 className='homepage_title'>Secure Industrial Data & Backups</h1>
                    <p className='homepage_description'>
                        Your industrial data is automatically backed up and securely stored.
                        Machine logs, sensor readings, and automation configurations
                        are protected with scheduled cloud backups.
                        Ensure business continuity and prevent data loss
                        with enterprise-grade security and redundancy.
                    </p>
                </div>
            </div>

            <div className='homepage_section'>
                <div className='homepage_sectionleft'>
                    <h1 className='homepage_title'>Industries We Serve</h1>
                    <ul>
                        <li><strong>Manufacturing:</strong> Automate assembly lines, robotic systems, and production workflows.</li>
                        <li><strong>Factories:</strong> Monitor machine performance, energy usage, and equipment health.</li>
                        <li><strong>Oil & Gas:</strong> Control pumps, valves, pipelines, and remote industrial assets.</li>
                        <li><strong>Energy & Utilities:</strong> Manage power systems, substations, and grid automation.</li>
                        <li><strong>Warehousing & Logistics:</strong> Automate conveyor systems and inventory handling equipment.</li>
                        <li><strong>Food & Beverage:</strong> Monitor temperature control, packaging lines, and compliance systems.</li>
                        <li><strong>Heavy Industry:</strong> Track and control large-scale industrial machinery and infrastructure.</li>
                    </ul>
                </div>
                <div className='homepage_sectionright'>
                    <img className='homepage_image' src={homepage_section3} alt="Industries We Serve" />
                </div>
            </div>

            <div className='homepage_footer'>
                <div className='homepage_footercolumn'>
                    <div className='homepage_footertitle'>Contact Us</div>
                    <div className='homepage_footercontact'>Email: propertydynamicsfm@gmail.com</div>
                </div>
                <div className='homepage_footercolumn'>
                    <div className='homepage_socialicon' title="Facebook">
                        <a href={configData.FACEBOOKLINK} target="_blank" rel="noopener noreferrer">
                            <img className='homepage_facebookicon' src={homepage_facebookicon} alt="Facebook Icon" />
                        </a>
                    </div>
                    <div className='homepage_socialicon' title="LinkedIn">
                        <a href={configData.LINKEDINLINK} target="_blank" rel="noopener noreferrer">
                            <img className='homepage_linkedinicon' src={homepage_linkedinicon} alt="LinkedIn Icon" />
                        </a>
                    </div>
                    <div className='homepage_socialicon' title="Instagram">
                        <a href={configData.INSTAGRAMLINK} target="_blank" rel="noopener noreferrer">
                            <img className='homepage_instagramicon' src={homepage_instagramicon} alt="Instagram Icon" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Homepage;